export default "__VITE_ASSET__BP9AC0Hr__"